import { render } from "./home.vue?vue&type=template&id=669ba8a6&scoped=true"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"

import "./home.css?vue&type=style&index=0&id=669ba8a6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669ba8a6"]])

export default __exports__